<template>
  <div class="flex flex-col justify-center items-center pb-8 lg:pb-12">
    <div
      class="gap-6 items-center mx-auto max-w-screen-xl flex flex-col text-center justify-center pt-8 px-4 lg:py-12 lg:px-6"
    >
      <div class="font-light text-gray-500 sm:text-lg">
        <h2 class="mb-4 text-3xl tracking-tight font-semibold text-gray-900">
          Informationen für Gruppen
        </h2>
        <p class="mb-4">
          Bei Gruppenbuchungen ab 10 Personen bitten wir Sie, unser
          Vorverkaufsformular herunterzuladen und per E-Mail an uns zu senden.
          Dies gilt auch für Schulen, Kindergärten und andere Einrichtungen,
          selbst wenn die Gruppengröße kleiner ist.
        </p>
      </div>
    </div>
    <div className="rounded-xl p-6 mt-8 mx-auto max-w-screen-lg">
      <div class="max-w-4xl w-full rounded-xl overflow-hidden">
        <div class="relative">
          <div
            class="absolute top-5 left-5 w-[calc(100%-2.5rem)] h-1 md:bg-gray-700"
          ></div>
          <ol
            class="relative z-10 flex flex-col sm:flex-row justify-between items-start sm:items-center"
          >
            <li
              v-for="(step, index) in steps"
              :key="step.id"
              class="flex flex-col items-center w-full sm:w-1/3"
            >
              <div
                class="w-10 h-10 flex items-center justify-center rounded-full bg-primary text-white font-bold text-xl mb-4"
              >
                {{ index + 1 }}
              </div>
              <div class="flex flex-col items-center text-center px-4">
                <h3 class="text-lg font-semibold text-black mb-2">
                  {{ step.title }}
                </h3>
                <p class="text-gray-500 text-sm" v-html="step.description"></p>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </div>
    <a
      class="button mt-5"
      href="/download/Circus2025_Anmeldung_Schulen_Kindergaerten.pdf"
      download
      data-umami-event="presale_group_form_downloaded"
    >
      Formular herunterladen
    </a>
  </div>
</template>

<script lang="ts" setup>
import { CheckCircle, CloudDownload, Pen } from "lucide-vue-next";

const steps = ref([
  {
    id: 1,
    title: "Formular herunterladen",
    description:
      "Laden Sie das PDF-Formular über den untenstehenden Link herunter.",
    icon: CloudDownload,
  },
  {
    id: 2,
    title: "Formular ausfüllen",
    description:
      "Füllen Sie das Formular mit allen benötigten Angaben vollständig aus.",
    icon: Pen,
  },
  {
    id: 3,
    title: "Formular senden",
    description: `Senden Sie das ausgefüllte Formular per E-Mail an <a href='mailto:tickets@circusdirektor.de' class='link'>tickets@circusdirektor.de</a>`,
    icon: CheckCircle,
  },
]);
</script>
